// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite/no-important'
import { colors } from '@lmc/common/constants'

class IconSquircle extends Component<any, any> {
  renderLabel() {
    const { isListView, isCarePlans, subLabel, label, labelStyles } = this.props

    const _label = isCarePlans
      ? label
      : (label.split('/')[1] || label).replace(/^\s/, '')

    if (isListView) {
      return (
        <p className={css(classes.listLabelConatiner)}>
          <span className={css(classes.label)} style={labelStyles}>
            {_label}
          </span>
          <br />
          <span className={css(classes.subLabel)}>{subLabel}</span>
        </p>
      )
    } 
      return <p style={{ fontWeight: isCarePlans ? 'bold' : null }}>{_label}</p>
    
  }

  render() {
    const {
      icon,
      isListView,
      disabled = false,
      color,
      style,
      label,
      subLabel,
      onSelect,
      size,
    } = this.props

    const btnSize = size || 60
    const containerStyle = isListView
      ? {
          ...style,
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          textAlign: 'left',
        }
      : {
          ...style,
          textAlign: 'center',
        }

    const containerClass = disabled
      ? css(classes.container)
      : `${css(classes.container)} ${css(classes.selectable)}`

    return (
      <div className={containerClass} style={containerStyle} onClick={onSelect}>
        <div
          id="lmc-selectable-icon"
          className={css(classes.iconButton)}
          style={{
            backgroundColor: color || colors.background,
            width: btnSize,
            height: btnSize,
            margin: isListView ? 0 : '0 auto',
            flexShrink: 0,
          }}
        >
          <img
            alt=""
            src={icon}
            style={{
              marginTop: btnSize / 4 - 4, // 4px to adjust for the border
              height: btnSize / 2 || 30,
            }}
          />
        </div>
        {(label || subLabel) && this.renderLabel()}
      </div>
    )
  }
}

IconSquircle.propTypes = {
  onSelect: PropTypes.func,
  size: PropTypes.number,
}

const classes = StyleSheet.create({
  container: {
    // padding: 3,
    display: 'inline-block',
    verticalAlign: 'top',
  },
  selectable: {
    cursor: 'pointer',
    ':hover #lmc-selectable-icon': {
      border: '3px solid rgba(255,255,255,0.5)',
    },
  },
  iconButton: {
    width: 60,
    height: 60,
    textAlign: 'center',
    transition: 'border 0.2s ease-in-out',
    border: '3px solid rgba(255,255,255,0)',
    borderRadius: 10,
    margin: '0 auto',
  },
  label: {
    fontSize: 18,
  },
  subLabel: {
    opacity: 0.8,
    fontSize: 12,
  },
  listLabelConatiner: {
    marginTop: 4,
    marginBottom: 0,
    marginLeft: 10,
    lineHeight: '16px',
  },
})

export default IconSquircle
